<template>
  <div v-if="renderReady">
    <label v-if="getTitle" class="label">
      <template v-if="!setTitleAsPlaceholder">{{getTitle}}</template>
      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{tooltipContent}}</w-tooltip>
    </label>
    <div
      class="input"
      :class="{'state-error': model.$error, 'state-disabled': disabled && !borderless}"
    >
      <i
        class="icon-prepend fa"
        v-if="prependicon || $slots.prependicon"
        :class="prependicon && prependicon.startsWith('fa-') ? prependicon : ''"
      >
        <slot
          name="prependicon"
          class="icon-prepend"
        >{{prependicon.startsWith('fa-') ? '' : prependicon}}</slot>
      </i>
      <input
        :placeholder="getPlaceholder"
        ref="input"
        type="text"
        :class="['form-control', {'borderless': borderless, 'text-right': textRight}, css]"
        :style="appendiconTextRight"
        :disabled="disabled"
        :readonly="model.$schema.readOnly"
        :value="svalue"
        @input="onInput($event)"
        @focus="onFocus($event)"
        @blur="onBlur($event)"
        @mouseover="mouseOver($event)"
        @mouseleave="mouseOut($event)"
        :id="model.$form.generateId ? model.$pathId : undefined"
        :name="model.$form.testPath ? model.$path : undefined"
      />
      <i
        class="icon-append fa"
        v-if="appendicon || $slots.appendicon"
        :class="appendicon && appendicon.startsWith('fa-') ? appendicon : ''"
      >
        <slot
          name="appendicon"
          class="icon-append"
        >{{appendicon.startsWith('fa-') ? '' : appendicon}}</slot>
      </i>
    </div>
    <w-error v-if="showError" :model="model" @focus="$refs.input.focus();"></w-error>
  </div>
</template>

<script>
//         v-tooltip.notrigger="{content: tooltipContent, visible: !getTitle && tooltipVisibility}"

import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';
import WTooltip from './tooltip.vue';

export default {
  name: 'w-input',
  components: {WError, WTooltip},
  props: {
    placeholder: String,
    appendicon: {
      type: String,
      default: ''
    },
    prependicon: {
      type: String,
      default: ''
    },
    setTitleAsPlaceholder: {
      type: Boolean,
      default: false
    },
    showError: {
      type: Boolean,
      default: true
    },
    css: [Object, String, Array]
  },
  mixins: [modelMixin],
  data() {
    return {
      placeHolder: ''
    };
  },
  computed: {
    textRight() {
      return this.model.$schema.type === 'number' || this.model.$schema.type === 'money' || this.model.$schema.type === 'integer';
    },
    appendiconTextRight() {
      return this.textRight && this.appendicon ? {paddingRight: '35px!important'} : {};
    },
    getPlaceholder() {
      this.placeHolder = this.placeholder;
      if (this.setTitleAsPlaceholder) {
        this.placeHolder = this.getTitle;
        return this.placeHolder;
      } else {
        return this.placeHolder;
      }
    }
  },
  methods: {}
};
</script>

<style>
.icon-prepend .checkbox,
.icon-appendicon .checkbox {
  left: 1px !important;
  position: relative !important;
  top: -2px !important;
}
.noborderdisabled td.input .icon-prepend label.checkbox,
.noborderdisabled td.input .icon-appendicon label.checkbox { 
    margin-top: auto;
    margin-left: auto;
}
</style>